import { ICompany } from "../typings/Company";

export const isCurrentRoute = (route: string) => {
  return window.location.pathname.includes(route);
};

export const hasFeature = (company: ICompany | undefined, featureKey: string) => {
  return !!company?.storeFeatures.find((feature) => feature.name === featureKey);
};
